import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AccountingCode\GetAccountingCodeByIdController::__invoke
* @see app/Http/Controllers/AccountingCode/GetAccountingCodeByIdController.php
* @route '/api/accounting-code/{accounting_code}'
*/
const GetAccountingCodeByIdController = (args: { accounting_code: string | number | { id: string | number } } | [accounting_code: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAccountingCodeByIdController.url(args, options),
    method: 'get',
})

GetAccountingCodeByIdController.definition = {
    methods: ["get","head"],
    url: '/api/accounting-code/{accounting_code}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AccountingCode\GetAccountingCodeByIdController::__invoke
* @see app/Http/Controllers/AccountingCode/GetAccountingCodeByIdController.php
* @route '/api/accounting-code/{accounting_code}'
*/
GetAccountingCodeByIdController.url = (args: { accounting_code: string | number | { id: string | number } } | [accounting_code: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { accounting_code: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { accounting_code: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            accounting_code: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        accounting_code: typeof args.accounting_code === 'object'
        ? args.accounting_code.id
        : args.accounting_code,
    }

    return GetAccountingCodeByIdController.definition.url
            .replace('{accounting_code}', parsedArgs.accounting_code.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountingCode\GetAccountingCodeByIdController::__invoke
* @see app/Http/Controllers/AccountingCode/GetAccountingCodeByIdController.php
* @route '/api/accounting-code/{accounting_code}'
*/
GetAccountingCodeByIdController.get = (args: { accounting_code: string | number | { id: string | number } } | [accounting_code: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAccountingCodeByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AccountingCode\GetAccountingCodeByIdController::__invoke
* @see app/Http/Controllers/AccountingCode/GetAccountingCodeByIdController.php
* @route '/api/accounting-code/{accounting_code}'
*/
GetAccountingCodeByIdController.head = (args: { accounting_code: string | number | { id: string | number } } | [accounting_code: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetAccountingCodeByIdController.url(args, options),
    method: 'head',
})

export default GetAccountingCodeByIdController